import { styled } from "styled-components";
import { device } from "../../styles/style";

export const PostDiv = styled.div`
  position: absolute;
  top: 55%;
  left: 50%;
  transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
    translateX(280px);
  transition: 1s ease;

  @media ${device.mobileS} and ${device.tablet} {
    top: 45%;
    left: 45%;
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(100px);
  }

  @media ${device.laptop} and ${device.laptopMax} {
    top: 48%;
    left: 41%;
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(240px);
  }

  @media ${device.laptopL} {
    left: calc(43%);
  }

  @media (min-width: 1025px) {
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(300px);
    top: 47%;
    left: 39%;
  }

  @media${device.tv} {
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(400px);
  }

  @media${device.tvL} {
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(500px);
    left: calc(50% - 100px);
  }
  @media${device.uhd} {
    transform: rotate(${(props) => props.$degPostsCalc * props.$index}deg)
      translateX(800px);
    left: calc(50% - 150px);
  }
`;

export const Container = styled.div`
  position: relative;
  width: 300px;
  height: 300px;

  @media ${device.laptop} and ${device.laptopMax} {
    width: 600px;
    height: 600px;
  }

  @media (min-width: 1025px) {
    width: 600px;
    height: 600px;
  }

  @media${device.tv} {
    width: 1000px;
    height: 1000px;
  }

  @media${device.tvL} {
    width: 1200px;
    height: 1200px;
  }
  @media${device.uhd} {
    width: 1600px;
    height: 1600px;
  }
`;
